import { render } from "./ReferralAddBranch.vue?vue&type=template&id=7cb89817&ts=true"
import script from "./ReferralAddBranch.ts?vue&type=script&lang=ts&external"
export * from "./ReferralAddBranch.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__